// extracted by mini-css-extract-plugin
module.exports = {"movies-container":"Movies_movies-container__10B2n","pagination":"Movies_pagination__3DI2Q"};